import type { RouteObject } from 'react-router';

import { TagsPage } from './Tags';

/**
 * The flat tag vocabulary. One `RouteObject`, so the file is `.route.tsx`
 * singular; the feature's two routes are aggregated in `taxonomy.routes.tsx`.
 *
 * Two levels of breadcrumb, for the same reason its sibling carries two:
 * `taxonomy/` is a segment in the URL and a bucket in the pack, and there is no
 * `/taxonomy` page for a crumb to lead to.
 *
 * It sits inside the console layout route, which already runs the guard chain,
 * so this route adds no loader of its own. The guard decides **navigation**;
 * `backend-content` authorizes every read and every write on the request itself.
 */
export const tagsRoute: RouteObject = {
  path: 'taxonomy/tags',
  element: <TagsPage />,
};
